import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import ContactForm from '../../components/ContactForm/ContactForm';
import './ContactPage.css';

const ContactPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="contact-page">
            <motion.div
                className="page-header"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h1>{t('contact.title')}</h1>
                <p>{t('contact.subtitle')}</p>
            </motion.div>

            <div className="contact-container">
                <motion.div
                    className="contact-info"
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <div className="info-card">
                        <h3>{t('contact.info.dispatch_service')}</h3>
                        <p>{t('contact.info.dispatch_24_7')}</p>
                        <p>{t('contact.info.phone')}</p>
                        <p>{t('contact.info.mobile')}</p>
                    </div>

                    <div className="info-card">
                        <h3>{t('contact.info.availability')}</h3>
                        <p>{t('contact.info.dispatch_24_7')}</p>
                    </div>

                    <div className="info-card">
                        <h3>{t('contact.info.email_title')}</h3>
                        <p>acs-dispatch@ala-catering.kz</p>
                        <p>sales@ala-catering.kz</p>
                    </div>
                </motion.div>

                <motion.div
                    className="contact-form-wrapper"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                >
                    <ContactForm />
                </motion.div>
            </div>
        </div>
    );
};

export default ContactPage;
